import { useCallback, useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { Warehouse, RefreshCw } from "lucide-react";
import api, { formatApiError } from "@/lib/api";
import PanelAlmacen from "@/components/almacen/PanelAlmacen";
import TablaExistencias from "@/components/almacen/TablaExistencias";
import PanelConsumibles from "@/components/almacen/PanelConsumibles";
import FichaInsumo from "@/components/almacen/FichaInsumo";
import ConteosTab from "@/components/almacen/ConteosTab";
import ParametrosTab from "@/components/almacen/ParametrosTab";

const TABS = [["panel", "Panel"], ["existencias", "Existencias"], ["conteos", "Conteo cíclico"], ["parametros", "Parámetros"]];

export default function Inventario() {
  const [params, setParams] = useSearchParams();
  const tab = params.get("tab") || "panel";
  const [sucs, setSucs] = useState([]);
  const [sid, setSid] = useState("");
  const [panel, setPanel] = useState(null);
  const [filas, setFilas] = useState([]);
  const [comps, setComps] = useState([]);
  const [estado, setEstado] = useState("");
  const [ficha, setFicha] = useState(null);
  const [cargando, setCargando] = useState(false);

  useEffect(() => { api.get("/sucursales").then((r) => { setSucs(r.data); setSid(r.data.find((s) => s.tipo === "almacen")?.id || r.data[0]?.id || ""); }).catch(() => {}); }, []);
  const cargar = useCallback(async () => {
    if (!sid) return;
    setCargando(true);
    try {
      const [p, e, c] = await Promise.all([api.get(`/almacen/panel?sucursal_id=${sid}`), api.get(`/almacen/existencias?sucursal_id=${sid}`), api.get(`/componentes?sucursal_id=${sid}`)]);
      setPanel(p.data); setFilas(e.data); setComps(c.data);
    } catch (e) { toast.error(formatApiError(e)); } finally { setCargando(false); }
  }, [sid]);
  useEffect(() => { cargar(); }, [cargar]);

  const setTab = (t) => { const p = new URLSearchParams(params); p.set("tab", t); setParams(p); };
  const suc = sucs.find((s) => s.id === sid);

  return (
    <div className="p-4 sm:p-6 lg:p-8 max-w-[1500px] mx-auto animate-fade-up" data-testid="inventario-page">
      <div className="flex items-start justify-between flex-wrap gap-4 mb-5">
        <div><div className="eyebrow mb-1">ERP · Gestión de almacén</div><h1 className="font-display text-2xl sm:text-3xl font-extrabold tracking-tight text-brand-ink flex items-center gap-2"><Warehouse className="w-7 h-7 text-brand-amber" /> {suc?.nombre || "Almacén"}</h1><p className="text-sm text-brand-muted mt-1">Visibilidad de stock con estándares de almacén: roturas, cobertura, clasificación ABC, kardex por insumo, conteo cíclico y sugerido de compra por proveedor aprendido.</p></div>
        <div className="flex items-center gap-2"><select data-testid="inv-branch-select" value={sid} onChange={(e) => setSid(e.target.value)} className="field w-64">{sucs.map((s) => <option key={s.id} value={s.id}>{s.nombre}{s.tipo === "almacen" ? " · Almacén Central" : s.tipo === "cedis" ? " · CEDIS" : ""}</option>)}</select><button data-testid="inv-refrescar" onClick={cargar} className="btn-soft h-10 w-10 p-0 flex items-center justify-center"><RefreshCw className={`w-4 h-4 ${cargando ? "animate-spin" : ""}`} /></button></div>
      </div>
      <div className="flex flex-wrap gap-1 mb-5" data-testid="inv-tabs">{TABS.map(([k, lab]) => <button key={k} data-testid={`inv-tab-${k}`} onClick={() => setTab(k)} className={`h-9 px-4 rounded-full text-sm font-bold transition-colors ${tab === k ? "bg-brand-ink text-white" : "bg-brand-surface text-brand-slate hover:bg-brand-line"}`}>{lab}</button>)}</div>
      {tab === "panel" && <div className="space-y-5"><PanelConsumibles sucursalId={sid} onCambio={cargar} /><PanelAlmacen p={panel} onVerEstado={(e) => { setEstado(e); setTab("existencias"); }} onAbrirInsumo={setFicha} /></div>}
      {tab === "existencias" && <TablaExistencias filas={filas} sucursalId={sid} estado={estado} setEstado={setEstado} onAbrirInsumo={setFicha} onCambio={cargar} />}
      {tab === "conteos" && sid && <ConteosTab sucursalId={sid} onCambio={cargar} />}
      {tab === "parametros" && <ParametrosTab comps={comps} cargar={cargar} esCentral={suc?.tipo === "almacen"} />}
      {ficha && <FichaInsumo componenteId={ficha} sucursalId={sid} onClose={() => setFicha(null)} />}
    </div>
  );
}
